import {Dispatch, ReactElement, SetStateAction} from "react";
import {NftOwnership} from "@devour/client";
import NftOwnershipImage from "@/components/NftOwnershipImage";
import isLootboxUnburnt from "@/utils/isLootboxUnburnt";

interface Props {
    nftOwnership: NftOwnership;
    setSelectedNft: Dispatch<SetStateAction<NftOwnership>>;
}

function GoVipRewardsInventoryDrawerCard(props: Props): ReactElement {
    function onClick() {
        if (!isLootboxUnburnt(props.nftOwnership)) {
            return;
        }
        props.setSelectedNft(props.nftOwnership);
    }

    return (
        <button
            className="govip-rewards-drawer_inventory_nfts_card"
            onClick={onClick}
        >
            {!isLootboxUnburnt(props.nftOwnership) &&
								<div className="govip-rewards-drawer_inventory_nfts_card_loading">
								    <div className="loading-spinner"/>
								</div>
            }
            <NftOwnershipImage
                className="govip-rewards-drawer_inventory_nfts_card_image"
                alt="GoFriends Card Thumbnail"
                ownership={props.nftOwnership}
            />
        </button>
    );
}

export default GoVipRewardsInventoryDrawerCard;